import React from "react";
import { personalInfo } from "../data/portfolioData";

const Contact: React.FC = () => {
  return (
    <section id="contact" className="section-padding">
      <div className="container-max">
        <div className="text-center mb-16">
          <h2 className="section-title">Get In Touch</h2>
          <p className="section-subtitle">
            I'm always interested in new opportunities and collaborations. Let's
            connect!
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-16 items-center">
          {/* Left Column - Contact Info */}
          <div className="space-y-10">
            <div>
              <h3 className="text-3xl font-bold text-white mb-8">
                Let's work together
              </h3>
              <p className="text-dark-300 leading-relaxed text-lg mb-8">
                I'm currently looking for machine learning engineering
                opportunities. Whether you have a question about my work, want
                to collaborate on a project, or just want to say hello, I'd love
                to hear from you!
              </p>
            </div>

            {/* Contact Methods */}
            <div className="space-y-8">
              <div className="flex items-center space-x-6">
                <div className="flex-shrink-0">
                  <div className="w-16 h-16 bg-primary-500/20 rounded-xl flex items-center justify-center border border-primary-500/30">
                    <svg
                      className="w-8 h-8 text-primary-400"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                      <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                    </svg>
                  </div>
                </div>
                <div>
                  <h4 className="text-xl font-semibold text-white mb-2">
                    Email
                  </h4>
                  <a
                    href={`mailto:${personalInfo.email}`}
                    className="text-primary-400 hover:text-primary-300 transition-colors text-lg"
                  >
                    {personalInfo.email}
                  </a>
                </div>
              </div>

              <div className="flex items-center space-x-6">
                <div className="flex-shrink-0">
                  <div className="w-16 h-16 bg-primary-500/20 rounded-xl flex items-center justify-center border border-primary-500/30">
                    <svg
                      className="w-8 h-8 text-primary-400"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path
                        fillRule="evenodd"
                        d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </div>
                </div>
                <div>
                  <h4 className="text-xl font-semibold text-white mb-2">
                    Location
                  </h4>
                  <p className="text-dark-300 text-lg">
                    {personalInfo.location}
                  </p>
                </div>
              </div>
            </div>

            {/* Social Links */}
            <div>
              <h4 className="text-xl font-semibold text-white mb-6">
                Connect with me
              </h4>
              <div className="flex space-x-4">
                <a
                  href={personalInfo.linkedin}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-16 h-16 bg-primary-500/20 hover:bg-primary-500/30 rounded-xl flex items-center justify-center transition-all duration-200 border border-primary-500/30 hover:border-primary-400/50 hover:scale-105"
                >
                  <svg
                    className="w-8 h-8 text-primary-400"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fillRule="evenodd"
                      d="M16.338 16.338H13.67V12.16c0-.995-.017-2.277-1.387-2.277-1.39 0-1.601 1.086-1.601 2.207v4.248H8.014v-8.59h2.559v1.174h.037c.356-.675 1.227-1.387 2.526-1.387 2.703 0 3.203 1.778 3.203 4.092v4.711zM5.005 6.575a1.548 1.548 0 11-.003-3.096 1.548 1.548 0 01.003 3.096zm-1.337 9.763H6.34v-8.59H3.667v8.59zM17.668 1H2.328C1.595 1 1 1.581 1 2.298v15.403C1 18.418 1.595 19 2.328 19h15.34c.734 0 1.332-.582 1.332-1.299V2.298C19 1.581 18.402 1 17.668 1z"
                      clipRule="evenodd"
                    />
                  </svg>
                </a>
                <a
                  href={personalInfo.github}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-16 h-16 bg-primary-500/20 hover:bg-primary-500/30 rounded-xl flex items-center justify-center transition-all duration-200 border border-primary-500/30 hover:border-primary-400/50 hover:scale-105"
                >
                  <svg
                    className="w-8 h-8 text-primary-400"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fillRule="evenodd"
                      d="M10 0C4.477 0 0 4.484 0 10.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0110 4.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.203 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.942.359.31.678.921.678 1.856 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0020 10.017C20 4.484 15.522 0 10 0z"
                      clipRule="evenodd"
                    />
                  </svg>
                </a>
              </div>
            </div>
          </div>

          {/* Right Column - Contact Form Placeholder */}
          <div className="card">
            <h3 className="text-2xl font-bold text-white mb-8">
              Send me a message
            </h3>
            <div className="space-y-6">
              <div>
                <label className="block text-sm font-medium text-white mb-3">
                  Name
                </label>
                <input
                  type="text"
                  className="w-full px-4 py-3 bg-dark-700 border border-dark-600 rounded-xl focus:ring-2 focus:ring-primary-500 focus:border-transparent text-white placeholder-dark-400"
                  placeholder="Your name"
                  disabled
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-white mb-3">
                  Email
                </label>
                <input
                  type="email"
                  className="w-full px-4 py-3 bg-dark-700 border border-dark-600 rounded-xl focus:ring-2 focus:ring-primary-500 focus:border-transparent text-white placeholder-dark-400"
                  placeholder="your.email@example.com"
                  disabled
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-white mb-3">
                  Message
                </label>
                <textarea
                  rows={4}
                  className="w-full px-4 py-3 bg-dark-700 border border-dark-600 rounded-xl focus:ring-2 focus:ring-primary-500 focus:border-transparent text-white placeholder-dark-400"
                  placeholder="Your message..."
                  disabled
                ></textarea>
              </div>
              <button
                className="w-full btn-primary opacity-50 cursor-not-allowed"
                disabled
              >
                Send Message
              </button>
              <p className="text-sm text-dark-400 text-center">
                Contact form coming soon. For now, please email me directly!
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
